import React from 'react';
import { Box, Badge, useTheme } from '@ublend-npm/aulaui-core';
import PageView from './common/PageView';
import AllConversationsView from './common/AllConversationsView';
import { hashHistory } from 'react-router';
import { Typography } from '@ublend-npm/aulaui-core';
import { useSelector } from 'react-redux';

import { selectorsResponsive } from '@app/store/conversations';
import { currentUserId } from '@core/selectors/user';
import { conversationLatestMessage } from '@core/conversations/selectorsResponsive';

const MESSAGE_ROUTE_PREFIX = '/home/messages/';

const AllConversationsPageView: React.FC = () => {
  const { palette } = useTheme();

  const handleConversationClick = (conversationId: string): void => {
    hashHistory.push(`${MESSAGE_ROUTE_PREFIX}${conversationId}`);
  };

  const conversations = useSelector(selectorsResponsive.paginatedConversations);
  const userId = useSelector(currentUserId);

  const totalUnreadCount = useSelector((state: any): number => {
    if (!userId) {
      return 0;
    }

    return conversations.filter((conversation) => {
      const isUnread = selectorsResponsive.isConversationUnreadBy?.(
        state,
        conversation.id,
        userId
      );

      if (!isUnread) {
        return false;
      }

      const latestMessage = conversationLatestMessage(state, conversation.id);

      return latestMessage?.writer !== userId;
    }).length;
  });

  return (
    <PageView>
      <Box mb={1}>
        <Typography
          variant="subtitle1"
          component="h2"
          fontWeight="medium"
          color="primary"
          sx={{ display: 'inline-block' }}
        >
          Messages
        </Typography>
        {totalUnreadCount > 0 ? (
          <Badge
            badgeContent={totalUnreadCount}
            role="status"
            aria-live="polite"
            aria-label={`You have ${totalUnreadCount} unread messages`}
            color="primary"
            sx={{
              marginLeft: 2,
              '& .MuiBadge-badge': {
                backgroundColor: '#E8DCFC',
                color: palette.getContrastText('#E8DCFC'),
              },
            }}
          />
        ) : null}
      </Box>
      <AllConversationsView handleConversationClick={handleConversationClick} />
    </PageView>
  );
};

export default AllConversationsPageView;
